import React, { useEffect, useState } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ptBR from "date-fns/locale/pt-BR";

registerLocale("pt-BR", ptBR);

const StepOne = ({
  data,
  setData,
  horario,
  setHorario,
  setSelectedIdAgenda,
  nextStep,
}) => {
  const [loading, setLoading] = useState(false);
  const [agenda, setAgenda] = useState([]);
  const [horarios, setHorarios] = useState([]);

  // Buscar a agenda completa com horários
  const fetchAgendaCompleta = async (medicoIdFromUrl) => {
    try {
      let url = `${process.env.REACT_APP_URL_API}/agendaCompleta`;
      const medicoId = medicoIdFromUrl || sessionStorage.getItem("medicoId");
      if (medicoId) {
        url += `?medico=${medicoId}`;
      }
      console.log("URL da API:", url);
      const response = await fetch(url);
      const data = await response.json();
      console.log("Dados recebidos da API:", data);

      // Validar e limpar os dados
      const agendaLimpa = data.filter((item) => {
        if (!item.data_inicio) {
          console.warn(`Item ${item.id_agenda} sem data_inicio:`, item);
          return false;
        }
        return true;
      });

      console.log("Agenda limpa:", agendaLimpa);
      setAgenda(agendaLimpa);
    } catch (error) {
      console.error("Erro ao buscar agenda:", error);
    }
  };

  useEffect(() => {
    // Buscar o medicoId da URL (?i=) e salvar no sessionStorage
    const params = new URLSearchParams(window.location.search);
    const medicoId = params.get("i");
    if (medicoId) {
      sessionStorage.setItem("medicoId", medicoId);
    }
    fetchAgendaCompleta(medicoId);
  }, []);

  // Função para obter a data de hoje normalizada (sem horas)
  const getTodayNormalized = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  };

  // Função para obter a data de amanhã (data mínima permitida)
  const getTomorrow = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);
    return tomorrow;
  };

  // Calcular a data máxima (1 mês a partir de hoje)
  const hoje = getTodayNormalized();
  const maxDate = new Date(
    hoje.getFullYear(),
    hoje.getMonth() + 1,
    hoje.getDate()
  );
  maxDate.setHours(23, 59, 59, 999); // Fim do dia para incluir o dia completo

  // Extrair as datas únicas com horários disponíveis
  const datasDisponiveis = Array.from(
    new Set(
      agenda
        .filter((item) => item.data_inicio) // Filtrar apenas itens com data_inicio válida
        .map((item) => item.data_inicio.split("T")[0])
    )
  );

  console.log("Datas disponíveis extraídas:", datasDisponiveis);

  const datasDisponiveisAsDate = datasDisponiveis
    .map((dateStr) => {
      // Criar a data usando componentes locais para evitar problemas de fuso horário
      const [year, month, day] = dateStr.split("-");
      const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
      date.setHours(0, 0, 0, 0); // Normalizar horas para comparação
      console.log(
        `Convertendo data: ${dateStr} -> Date: ${date.toISOString()} -> Local: ${date.toLocaleDateString()}`
      );
      return date;
    })
    .filter((date) => {
      // Filtrar o dia atual e permitir apenas datas futuras até 1 mês
      const today = getTodayNormalized();
      return date.getTime() > today.getTime() && date <= maxDate;
    });

  console.log(
    "Datas disponíveis como objetos Date (filtradas):",
    datasDisponiveisAsDate
  );

  // Função para converter string de data para Date sem problemas de fuso horário
  const parseDateWithoutTimezone = (dateString) => {
    const [year, month, day] = dateString.split("-");
    return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  };

  // Função para normalizar data para comparação
  const normalizeDate = (dateString) => {
    if (!dateString) return null;
    // Se a data já está no formato YYYY-MM-DD, retorna como está
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
      return dateString;
    }
    // Se está no formato ISO, extrai apenas a parte da data
    if (dateString.includes("T")) {
      return dateString.split("T")[0];
    }
    // Se for uma data válida, converte para YYYY-MM-DD
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return null;
      return date.toISOString().split("T")[0];
    } catch (e) {
      console.warn("Erro ao converter data:", dateString, e);
      return null;
    }
  };

  // Quando o usuário escolher uma data
  const handleDateChange = (date) => {
    // Usar uma abordagem que não sofre com fuso horário
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const selected = `${year}-${month}-${day}`;

    setData(selected);

    console.log("Data selecionada (original):", date);
    console.log("Data selecionada (formatada):", selected);
    console.log("Agenda completa:", agenda);

    // Filtrar horários dessa data usando data_inicio
    const horariosData = agenda
      .filter((item) => {
        // Usar data_inicio em vez de data
        const itemDate = normalizeDate(item.data_inicio);
        const isStatusValid = item.status === 1; // Apenas horários disponíveis
        console.log(
          `Item ${item.id_agenda}: data_inicio=${
            item.data_inicio
          }, itemDate=${itemDate}, selected=${selected}, status=${
            item.status
          }, match=${itemDate === selected && isStatusValid}`
        );
        return itemDate === selected && isStatusValid;
      })
      .map((item) => ({
        id: item.id_agenda,
        name: item.hora_inicio.slice(0, 5),
      }))
      .sort((a, b) => a.name.localeCompare(b.name)); // Ordenar horários do menor para o maior

    console.log("Horários filtrados:", horariosData);
    setHorarios(horariosData);
    setHorario(""); // resetar o horário selecionado
    setSelectedIdAgenda && setSelectedIdAgenda(null); // resetar id_agenda se existir
  };

  const handleHorarioChange = (e) => {
    const selectedTime = e.target.value;
    setHorario(selectedTime);

    const selectedItem = horarios.find((item) => item.name === selectedTime);
    if (selectedItem && setSelectedIdAgenda) {
      setSelectedIdAgenda(selectedItem.id);
    } else if (setSelectedIdAgenda) {
      setSelectedIdAgenda(null);
    }
  };

  return (
    <>
      <div className="col-xl-6 col-lg-6 col-md-6">
        <label>Selecione uma data</label>
        <div className="mb-20">
          <DatePicker
            selected={data ? parseDateWithoutTimezone(data) : null}
            onChange={handleDateChange}
            includeDates={datasDisponiveisAsDate}
            minDate={getTomorrow()}
            maxDate={maxDate}
            dateFormat="dd/MM/yyyy"
            placeholderText="Escolha uma data"
            className="form-control"
            locale="pt-BR"
          />
        </div>
      </div>

      <div className="col-xl-6 col-lg-6 col-md-6">
        <label>Selecione um horário</label>
        <select
          value={horario}
          onChange={handleHorarioChange}
          className="form-select select_style"
          disabled={!data || horarios.length === 0}
        >
          <option value="">Selecione um horário</option>
          {horarios.map((item) => (
            <option key={item.id} value={item.name}>
              {item.name}
            </option>
          ))}
        </select>
        {data && horarios.length === 0 && (
          <p>Sem horários disponíveis nesta data.</p>
        )}
      </div>

      <button
        className="primary_btn mt-40"
        onClick={nextStep}
        disabled={!data || !horario}
      >
        Próximo
      </button>
    </>
  );
};

export default StepOne;
